import { useEffect } from "react";
import { toast } from "react-toastify";
import { useTour } from "@providers/TourProvider";

/** Rendered by ErrorBoundary when the tour system crashes. Cleans up side effects.
 *  TourProvider is above the ErrorBoundary, so useTour() works here and stopTour()
 *  clears activeTourId — without this, the entire app thinks a tour is still running
 *  (Help Menu buttons silently fail, recording warnings stay hidden, etc.). */
export default function TourCrashFallback() {
    const { stopTour } = useTour();
    useEffect(() => {
        // TourEngine sets overflow:hidden while active — restore scrollability on crash
        document.documentElement.style.overflow = "";
        stopTour();
        toast.warn("The tour ran into a problem and was stopped. You can restart it from the Help menu.", {
            autoClose: 6000,
        });
    }, [stopTour]);
    return null;
}
